module.exports = __webpack_public_path__ + "img/unlocking.c03ab78e.svg";